import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiConstants } from '@coreConstant';
import { BehaviorSubject, catchError, map, throwError } from 'rxjs';
import {PaginationModel} from "@coreModels";

@Injectable({
  providedIn: 'root'
})
export class SearchService {

  private payloadSource = new BehaviorSubject<any>(null);
  currentPayload = this.payloadSource.asObservable();

  constructor(private http: HttpClient) { }

  searchWithCount(formData: any) {
    return this.http.post(ApiConstants.SEARCH_WITH_COUNT_URL, formData)
      .pipe(
        map<any, any>(response => {
          return response.data;
        }),
        catchError((err: unknown) => {
          return throwError(() => err);
        })
      );
  }

  search(formData: any, requestParamModel: any) {
    return this.http.post(`${ApiConstants.SEARCH_URL}${requestParamModel ? requestParamModel.getParams() : ''}`, formData,{
      observe: 'response'
    })
      .pipe(
        map<any, any>(response => {
          const searchResult = new PaginationModel<any>();
          const headers = response.headers;
          searchResult.setHeaders(headers);
          searchResult.data = response.body.data as [];
          return searchResult;
        }),
        catchError((err: unknown) => {
          return throwError(() => err);
        })
      );
  }

  setPayload(payload: any) {
    this.payloadSource.next(payload);
  }
}
